export class Slider {
	/**
	 *
	 * @param {HTMLElement} node - the node that contains the root scrolling element
	 * @param {object} opts -
	 */
	constructor( node, opts ) {
		this.node = node;
		this.opts = {
			back: '.card-slider__go--back',
			forward: '.card-slider__go--forward',
			content: '.card-slider__content',
			items: '.card-slider__content > *',
			sticky: true,
			...opts,
		};

		if ( ! this.node ) {
			return;
		}

		this.interval = null;
		this.querySelectors();

		window.addEventListener( 'resize', this.setState.bind( this ) );
		this.content.addEventListener( 'scroll', this.setState.bind( this ) );

		this.forward.addEventListener( 'click', this.forwardIndex.bind( this ) );
		this.back.addEventListener( 'click', this.backIndex.bind( this ) );

		this.setIndex( 0 );
		this.setState();
	}

	querySelectors() {
		this.back = this.node.querySelector( this.opts.back );
		this.forward = this.node.querySelector( this.opts.forward );
		this.content = this.node.querySelector( this.opts.content );
		this.items = this.node.querySelectorAll( this.opts.items );

		if ( ! this.back ) {
			this.back = document.createElement( 'button' );
		}

		if ( ! this.forward ) {
			this.forward = document.createElement( 'button' );
		}
	}

	setState() {
		const firstItem = this.items[ 0 ];
		const lastItem = this.items[ this.items.length - 1 ];

		if ( firstItem && firstItem.offsetLeft - this.content.scrollLeft >= 0 ) {
			// first item is is view
			this.back.disabled = true;
		} else {
			// first item is outside the scroll area
			this.back.removeAttribute( 'disabled' );
		}

		if ( lastItem && this.content.scrollLeft + this.content.offsetWidth >= lastItem.offsetLeft + lastItem.offsetWidth - 1 ) {
			// the last item is fully in view
			this.forward.disabled = true;
		} else {
			// last item is outside the scroll area
			this.forward.removeAttribute( 'disabled' );
		}
	}

	getIndex() {
		const offset = this.getPaddingOffset();
		const distances = [ ...this.items ].map( ( item ) => Math.abs( item.offsetLeft - this.content.scrollLeft - offset ) );

		return distances.indexOf( Math.min( ...distances ) );
	}

	getPaddingOffset() {
		return Math.max( parseInt( getComputedStyle( this.content ).paddingLeft, 10 ), 0 );
	}

	setIndex( index, behavior = 'smooth' ) {
		if ( this.items.length > 0 && index <= this.items.length ) {
			const left = this.items[ index ].offsetLeft - this.getPaddingOffset();

			this.content.scrollTo( {
				left: Math.max( 0, left ),
				behavior,
			} );
		} else if ( this.scrollInterval > 0 ) {
			clearInterval( this.scrollInterval );
			this.scrollInterval = null;
		}
	}

	backIndex() {
		this.setIndex( Math.round( Math.max( this.getIndex() - 1, 0 ) ) );
	}

	forwardIndex() {
		this.setIndex( Math.round( Math.min( this.getIndex() + 1, this.items.length - 1 ) ) );
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.card-slider' ).forEach( ( node ) => {
		new Slider( node, { ...node.dataset } );
	} );
} );
